<template>
  <a-modal :name="Name">
    <div class="MessagePopUp" @click.self="closeModal">
      <div class="bg-color" ></div>
      <div class="MessagePopUp-modal">
        <div :style='"background-image:url(\""+MessagePopUp.img+"\");" ' class="img"></div>
        <h2 class="MessagePopUp-modal__title" :class="MessagePopUp.align">
          {{ MessagePopUp.title }}
        </h2>
        <p class="MessagePopUp-modal__text" :class="MessagePopUp.align" v-html="MessagePopUp.text"></p>
        <div class="MessagePopUp-buttons" v-if="MessagePopUp.actions">
          <ABtn
              v-for="btn in MessagePopUp.actions"
              @click.prevent="action(btn)"
              :label="btn.title"
              :bg="btn.bg"
              :color="btn.color"
              :type="btn.type"
          />
        </div>

      </div>
    </div>
  </a-modal>
</template>

<script>
import { reactive, ref } from 'vue';
import {useAModal, AModal, ABtn, useAProgressBar} from "~/components/ui";
import {useMessagePopUp} from "~/composables/useMessagePopUp";
import { send } from '~/services/api'
import {AUTH_STATES} from "../../store/modules/auth";
import {useStore} from "vuex";
export default {
  name: "MessagePopUp",
  components: {
    AModal,
    ABtn,
  },
  setup() {
    const Name = 'MessagePopUp';
    const modal = useAModal();
    const progress = useAProgressBar();
    const MessagePopUp = useMessagePopUp()?.MessagePopUp;
    const closeModal = () => {
      modal.hide();
    }
    const $store = useStore();
    const paternAction = async (btn) => {

      switch (btn.paternAction) {
        case 'reload':
          location.reload();
        break;
        case 'close':
          closeModal();
        break;
        case 'registration':
          location.href = '/registration/?type=volunteer';
          break;
        case 'registrationNpo':
          progress.show();
          if(btn?.options?.logoutLink) {
            await send(btn?.options?.logoutLink, {method: "POST"}, {}).then((response) => {
              location.href = '/registration/?type=company';
            });
          } else {
            location.href = '/registration/?type=company';
          }
          break;
          case 'login':
            modal.show('authPage-modal');
            $store.commit('auth/setAuthState', AUTH_STATES.login);
          break;
      }
    };
    const action = (btn) => {
      if(btn.action) {
        location.href=btn.action;
      } else if(btn.paternAction) {
        paternAction(btn);
      }
    }

    return {
      Name,
      MessagePopUp,
      action,
      closeModal,
    };

  }
}
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}
.img {
  width: 100%;
  height: 100px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.bg-color {
  width: 100%;
  height: 50vh;
  background: var(--c-secondary-200);
}
.MessagePopUp {
  min-height: 100vh;
  background-color: #fff;
}
.MessagePopUp-background{
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}
.MessagePopUp-modal{
  position: absolute;
  max-width: 684px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 45px 64px 60px 57px;
  width: 100%;
  max-height: 100vh;
  overflow-y: auto;
  @include mobile{
    padding: 20px;
  }
  &__title{
    margin: 0 0 36px;
  }
  &__text{
    font-size: 14px;
    line-height: 20px;
    color: #161515;
    margin-bottom: 12px;
  }
  &__subText{
    font-size: 12px;
    line-height: 16px;
    color: #68737D;
    margin-bottom: 29px;
  }
  :deep{
    .label{
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #68737D;
    }
    .field{
      margin-bottom: 29px;
    }
    .MessagePopUp-file{
      margin: 0 0 3px;
    }
  }
}
.MessagePopUp-reset{
  border: 1px solid #00A59E;
}
.MessagePopUp-add{
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #68737D;
  margin-bottom: 35px;
  cursor: pointer;
  &__icon{
    margin-right: 11px;
  }
}
.MessagePopUp-buttons{
  display: flex;
  justify-content: space-around;
  button {
  min-width: 130px;
  }
  @include mobile{
    display: grid;
    grid-gap: 23px;
    grid-template-columns: 1fr;
  }
}
.MessagePopUp-files{
  display: grid;
  grid-row-gap: 5px;
  margin-bottom: 15px;
}
</style>